import http from '../../services/http-common';

class UploadFilesService {
    uploadPIPdf(data) {
        // console.log(data.get)
        return http.post(`/TenantContractPM/Uploadfiles`, data);
      }
      
      getPIPDFFiles(id,companyID) {
        console.log(id)
        return http.get(`/TenantContractPM/UploadedFiles/${id}/${companyID}`);
      }
      deleteAllPdfByPIID(id,companyID) {
        console.log(companyID)
        return http.get(`/TenantContractPM/deleteAllUploadedFiles/${id}/${companyID}`);
      }
      deletePDFFilebyPIPDFID(data) {
        console.log(data)
        return http.put(`/TenantContractPM/deletebyid`,data);
      }
}

export default new UploadFilesService();